<div class="dashboard-content" style="padding: 120px 40px 50px">

  <div class="contests-container">
    <div class="contests-header">
      <h1>
        {{ "contests.title" | translate }}
      </h1>
      <div class="top-filters">
        <div class="search-bar">
          <div class="icon">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <input type="text" [placeholder]="'contests.title' | translate" [(ngModel)]="searchTerm"
            (ngModelChange)="applySearch()" class="form-control" autocapitalize="off" style="text-transform: none;" />
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>
            {{ 'contests.filter' | translate }}
          </span>
          <!-- Animated red dot when filters are active -->
          <span *ngIf="hasActiveFilters()" class="filter-active-dot"
            (click)="clearAllFilters(); $event.stopPropagation()" title="Click to clear filters">
          </span>
        </button>
        <div class="dropdown export-dropdown ">
          <button class="btn btn-light filter-btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <i class="fa-solid fa-file-export"></i>
            <span>{{ 'common.export' | translate }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadContest()">
                <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
                PDF
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
                <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
                Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <!-- Old Version -->
    <div class="custom-tabs-container">
      <div class="custom-tabs-header">
        <ul class="custom-nav-tabs" role="tablist">
          <li class="nav-item" style="position: relative;">
            <a (click)="setActiveTab('all_contest')" [class.active]="tabs_grid === 'all_contest'" class="nav-link"
              role="tab">
              {{ 'common.all-contests' | translate }}
              <span *ngIf="tabs_grid === 'all_contest' && totalContestLength > 0">
                ({{ totalContestLength }}) </span>
            </a>
          </li>

          <li class="nav-item" style="position: relative;">
            <a (click)="setActiveTab('completed')" [class.active]="tabs_grid === 'completed'" class="nav-link"
              role="tab">
              {{ 'contests.completed-contests' | translate }}
              <span *ngIf="tabs_grid === 'completed' && totalCompletedContestLength > 0">
                ({{ totalCompletedContestLength }})
              </span>
            </a>
          </li>

          <li class="nav-item" style="position: relative;">
            <a (click)="setActiveTab('draft')" [class.active]="tabs_grid === 'draft'" class="nav-link" role="tab">
              {{ 'contests.draft-contests' | translate }}
              <span *ngIf="tabs_grid === 'draft' && totalDraftContestLength > 0">
                ({{ totalDraftContestLength }})
              </span>
            </a>
          </li>
        </ul>

        <a class="btn btn-primary" [routerLink]="['/home/contest-type']">
          {{ 'contests.create-new' | translate }}
        </a>
        <!-- <a class="btn btn-primary" [routerLink]="['/home/contests/add']">
        Create New Contest
      </a> -->
      </div>
      <div class="tab-contents">
        <!-- Info Tab -->
        <div [class.active]="tabs_grid === 'all_contest'" class="tab-pane" role="tabpanel" id="all_contest">
          <div class="luqta-card">
            <div class="card-heading">
              <h3>
                {{ 'contests.all-contest' | translate }}
              </h3>
            </div>
            <nz-table nzBordered="false" #contestTable [nzData]="contest" [nzBordered]="true"
              [nzScroll]="{ x: '1200px' }" [nzFrontPagination]="false" [nzPageSize]="perPage" [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[5, 10, 20, 50]" [nzShowPagination]="true" [nzTotal]="totalContestLength"
              [nzPageIndex]="pageIndex" (nzPageSizeChange)="onPageSizeChange($event)"
              (nzPageIndexChange)="onPageIndexChange($event)"
              (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
              <thead>
                <tr>
                  <!-- <th nzWidth="50px" nzLeft>
                  <div class="d-flex justify-content-center align-items-center">
                    #
                  </div>
                </th> -->
                  <th nzWidth="300px">{{ "allContests.name" | translate }}</th>
                  <th nzWidth="150px">{{ 'contests.creation-date' | translate }}</th>
                  <th nzWidth="130px">{{ "allContests.accessCode" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.type" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.status" | translate }}</th>
                  <th nzWidth="140px">{{ "allContests.viewType" | translate }}</th>
                  <th nzWidth="180px">{{ "allContests.location" | translate }}</th>
                  <th nzWidth="250px">{{ "allContests.contestDate" | translate }}</th>
                  <th nzWidth="210px">
                    {{ "allContests.prizeAnnouncementDate" | translate }}
                  </th>
                  <!-- <th nzWidth="200px">{{ "allContests.sharingSetting" | translate }}</th> -->
                  <th nzWidth="180px">{{ "allContests.timeline" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.no_of_participate" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.levels" | translate }}</th>
                  <th nzWidth="200px">{{ "allContests.prize" | translate }}</th>
                  <th nzWidth="110px">{{ "allContests.integrated" | translate }}</th>
                  <th nzWidth="165px" nzRight>{{ "allContests.actions" | translate }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of contestTable.data; let i = index">
                  <!-- <td >
                  <div class="d-flex justify-content-center align-items-center">
                    {{ (pageIndex - 1) * pageSize + i + 1 }}
                  </div>
                </td> -->
                  <td>
                    <div class="contest-name">
                      <div class="image-group">
                        <img *ngFor="let banner of item.banners || []; let i = index" [src]="banner?.url"
                          class="banner-img clickable"
                          (click)="openImageModal(item.banners, i); $event.stopPropagation()" />
                      </div>
                      <span [innerHTML]="item.name | highlight : searchTerm"></span>
                    </div>
                  </td>

                  <td>{{ item.created_at | date }}</td>

                  <td>{{ item.access_code }}</td>

                  <td>
                    {{ item.type || item.contest_type || "-" }}
                  </td>

                  <td>
                    <span class="d-inline-flex align-items-center rounded text-white">
                      <div [ngSwitch]="getDisplayStatus(item)">
                        <!-- Draft -->
                        <span class="badge rounded-pill " *ngSwitchCase="'draft'">
                          Draft
                        </span>

                        <!-- Pending -->
                        <span class="badge rounded-pill" *ngSwitchCase="'pending'">
                          Pending
                        </span>

                        <!-- Waiting for Publish (approved but not active) -->
                        <span class="badge rounded-pill bg-warning" *ngSwitchCase="'waiting_publish'">
                          Waiting for Publish
                        </span>

                        <!-- Approved (not started yet) -->
                        <span class="badge rounded-pill bg-success" *ngSwitchCase="'approved'">
                          Approved
                        </span>

                        <!-- Rejected -->
                        <span class="badge rounded-pill bg-danger" *ngSwitchCase="'rejected'">
                          Rejected
                        </span>

                        <!-- Ongoing (approved + started + not ended) -->
                        <span class="badge rounded-pill bg-info" *ngSwitchCase="'ongoing'">
                          Ongoing
                        </span>

                        <!-- Waiting Prize (approved + ended + prize not announced) -->
                        <span class="badge rounded-pill bg-purple" *ngSwitchCase="'waiting_prize'">
                          Waiting Prize
                        </span>

                        <!-- Completed (prize announced from backend) -->
                        <span class="badge rounded-pill bg-success" *ngSwitchCase="'completed'">
                          Completed
                        </span>

                        <!-- Luqta Pending -->
                        <span class="badge rounded-pill bg-luqta-pending" *ngSwitchCase="'luqta_pending'">
                          Luqta Pending
                        </span>

                        <!-- Default -->
                        <span class="badge rounded-pill bg-dark" *ngSwitchDefault>
                          {{ getStatusLabel(item.status) }}
                        </span>
                      </div>
                    </span>
                  </td>

                  <td>
                    <span class="badge d-inline-flex align-items-center rounded " [ngClass]="
                  item.View_Type?.toLowerCase() === 'vip' ||
                  item.view_type?.toLowerCase() === 'vip' ||
                  item.viewType?.toLowerCase() === 'vip'
                    ? 'bg-warning'
                    : 'bg-info'
                ">
                      {{ item.View_Type || item.view_type || item.viewType || "Normal" }}
                    </span>
                  </td>

                  <td>
                    <div class="d-flex gap-1 justify-content-center align-items-center"
                      style="flex-wrap: wrap; overflow: visible;">
                      <span class="location-pills" *ngFor="let loc of getLocationArray(item).slice(0, 2)">
                        {{ loc }}
                      </span>
                      <span class="location-pills" *ngIf="hasMoreThanTwoLocations(item)"
                        [nz-tooltip]="getRemainingLocations(item)" nzTooltipPlacement="top" style="cursor: help;">
                        ...
                      </span>
                    </div>
                  </td>

                  <td>
                    <ng-container *ngIf="item.start_date; else noStart">
                      {{ item.start_date | date }}
                    </ng-container>
                    -
                    <ng-container *ngIf="item.end_date; else noEnd">
                      {{ item.end_date | date }}
                    </ng-container>

                    <ng-template #noStart>-</ng-template>
                    <ng-template #noEnd>-</ng-template>
                  </td>

                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="item.prize_announce_date; else noPrizeDate">
                        {{ item.prize_announce_date | date }}
                      </ng-container>
                      <ng-template #noPrizeDate>-</ng-template>
                    </div>
                  </td>

                  <!-- <td>
            <div class="d-flex justify-content-center align-items-center">
              <ng-container *ngIf="item.sharingSetting; else noShare">
                {{
                item.sharingSetting == "single" ? "Single" : "Invites Only"
                }}
              </ng-container>
              <ng-template #noShare>-</ng-template>
            </div>
          </td> -->

                  <td>
                    {{ getTimeRemaining(item.end_date) }}
                  </td>
                  <td>
                    <ng-container *ngIf="item.contest_participate > 0; else noParticipate">
                      <span>{{ item.contest_participate }}</span>
                    </ng-container>
                    <ng-template #noParticipate><span>0</span></ng-template>
                  </td>

                  <td>
                    <ng-container *ngIf="item.level_count > 0; else noLevels">
                      <span>
                        {{ item.level_count }}
                      </span>
                    </ng-container>
                    <ng-template #noLevels>
                      <span>-</span>
                    </ng-template>
                  </td>

                  <td>
                    {{ getPrizeNames(item._contest_prize) }}
                  </td>


                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="
                  item.format_of_contest == 'integrated' ||
                    item.format_of_contest == 'intergrated';
                  else notIntegrated
                ">
                        <!-- ✅ Integrated Format (Green Check Icon) -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#7ed321" stroke-width="2" />
                          <path d="M8 12.75C8 12.75 9.6 13.6625 10.4 15C10.4 15 12.8 9.75 16 8" stroke="#7ed321"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-container>

                      <!-- ❌ Not Integrated Format (Brown Cross Icon) -->
                      <ng-template #notIntegrated>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#F40531" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#F40531" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-template>
                    </div>
                  </td>

                  <td nzRight>
                    <div class="table-action-btns">
                      <!-- eye button  -->
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" (click)="showContestDetail(item)"
                        xmlns="http://www.w3.org/2000/svg" nz-tooltip nzTooltipTitle="View Contest">
                        <mask id="mask0_40000187_8448" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8448)">
                          <path
                            d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                            fill="#1C1B1F" />
                        </g>
                      </svg>

                      <!-- 👥 Participants Icon -->
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        (click)="viewParticipants(item.id, item.name)" xmlns="http://www.w3.org/2000/svg" nz-tooltip
                        nzTooltipTitle="View Participants" style="cursor: pointer">
                        <path
                          d="M17 20C17 18.3431 14.7614 17 12 17C9.23858 17 7 18.3431 7 20M21 17.0004C21 15.7702 19.7659 14.7129 18 14.25M3 17.0004C3 15.7702 4.2341 14.7129 6 14.25M18 10.2361C18.6137 9.68679 19 8.8885 19 8C19 6.34315 17.6569 5 16 5C15.2316 5 14.5308 5.28885 14 5.76389M6 10.2361C5.38625 9.68679 5 8.8885 5 8C5 6.34315 6.34315 5 8 5C8.76835 5 9.46924 5.28885 10 5.76389M12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14Z"
                          stroke="#1C1B1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>

                      <!-- ✏️ Edit Icon -->

                      <svg (click)="(hasSdkAccess || (item.status !== 'approved' && item.status !== 'completed')) && editContest(item.id)"
                        class="edit" nz-tooltip [nzTooltipTitle]="
                  !hasSdkAccess && item.status === 'approved' ? null : 'Edit Contest'
                " viewBox="0 0 24 24" width="20" height="20" fill="none"
                        [ngClass]="{ 'opacity-50': !hasSdkAccess && (item.status === 'approved' || item.status === 'completed') }"
                        [style.cursor]="
                  !hasSdkAccess && (item.status === 'approved'|| item.status === 'completed') ? 'not-allowed' : 'pointer'
                " width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.48148 11.8519H2.53704L9.77778 4.61111L8.72222 3.55556L1.48148 10.7963V11.8519ZM0 13.3333V10.1852L9.77778 0.425926C9.92593 0.290123 10.0895 0.185185 10.2685 0.111111C10.4475 0.037037 10.6358 0 10.8333 0C11.0309 0 11.2222 0.037037 11.4074 0.111111C11.5926 0.185185 11.7531 0.296296 11.8889 0.444444L12.9074 1.48148C13.0556 1.61728 13.1636 1.77778 13.2315 1.96296C13.2994 2.14815 13.3333 2.33333 13.3333 2.51852C13.3333 2.71605 13.2994 2.90432 13.2315 3.08333C13.1636 3.26235 13.0556 3.42593 12.9074 3.57407L3.14815 13.3333H0ZM9.24074 4.09259L8.72222 3.55556L9.77778 4.61111L9.24074 4.09259Z"
                          fill="#1C1B1F" />
                      </svg>



                      <svg *ngIf="hasSdkAccess || (item.status !== 'approved' &&  item.status !== 'completed'); else disabledDelete"
                        (click)="confirmDeleteContest(item.id, item.name)" class="delete" nz-tooltip
                        nzTooltipTitle="Delete Contest" style="cursor: pointer" width="18" height="18"
                        viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_40000187_8454" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8454)">
                          <path
                            d="M5.18707 15.556C4.77966 15.556 4.43089 15.4109 4.14077 15.1208C3.85065 14.8307 3.70558 14.4819 3.70558 14.0745V4.44488H2.96484V2.9634H6.66855V2.22266H11.113V2.9634H14.8167V4.44488H14.076V14.0745C14.076 14.4819 13.9309 14.8307 13.6408 15.1208C13.3506 15.4109 13.0019 15.556 12.5945 15.556H5.18707ZM12.5945 4.44488H5.18707V14.0745H12.5945V4.44488ZM6.66855 12.593H8.15003V5.92636H6.66855V12.593ZM9.63151 12.593H11.113V5.92636H9.63151V12.593Z"
                            fill="#F40531" />
                        </g>
                      </svg>




                      <ng-template #disabledDelete>

                        <svg width="18" height="18" class="delete opacity-50" viewBox="0 0 18 18" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_40000187_8454" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="18" height="18">
                            <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_40000187_8454)">
                            <path
                              d="M5.18707 15.556C4.77966 15.556 4.43089 15.4109 4.14077 15.1208C3.85065 14.8307 3.70558 14.4819 3.70558 14.0745V4.44488H2.96484V2.9634H6.66855V2.22266H11.113V2.9634H14.8167V4.44488H14.076V14.0745C14.076 14.4819 13.9309 14.8307 13.6408 15.1208C13.3506 15.4109 13.0019 15.556 12.5945 15.556H5.18707ZM12.5945 4.44488H5.18707V14.0745H12.5945V4.44488ZM6.66855 12.593H8.15003V5.92636H6.66855V12.593ZM9.63151 12.593H11.113V5.92636H9.63151V12.593Z"
                              fill="#F40531" />
                          </g>
                        </svg>
                      </ng-template>



                      <!-- ✅ Share button - Only for approved & active contests -->
                      <div *ngIf="isContestShareable(item)" class="share-container"
                        [class.show-icons]="activeShareId === item.id" (mouseleave)="hideShareIcons()">
                        <div class="share-icon" (mouseenter)="showShareIcons(item.id)"
                          (click)="shareOnSocial($event, 'copy', item)">
                          <i class="fa-solid fa-share-nodes default-icon"></i>
                          <i class="fa-solid fa-copy hover-icon"></i>
                        </div>

                        <div class="social-circle">
                          <a (click)="shareOnSocial($event, 'twitter', item)" class="social-icon"
                            title="Share on Twitter">
                            <i class="fa-brands fa-twitter"></i>
                          </a>

                          <a (click)="shareOnSocial($event, 'whatsapp', item)" class="social-icon"
                            title="Share on WhatsApp">
                            <i class="fa-brands fa-whatsapp"></i>
                          </a>

                          <a (click)="shareOnSocial($event, 'linkedin', item)" class="social-icon"
                            title="Share on LinkedIn">
                            <i class="fa-brands fa-linkedin"></i>
                          </a>

                          <a (click)="shareOnSocial($event, 'email', item)" class="social-icon" title="Share via Email">
                            <i class="fa-solid fa-envelope"></i>
                          </a>

                          <a (click)="shareOnSocial($event, 'facebook', item)" class="social-icon"
                            title="Share on Facebook">
                            <i class="fa-brands fa-facebook"></i>
                          </a>
                        </div>
                      </div>


                      <ng-template #iconTpl>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                          style="margin-right: 5px" color="#d0021b" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"></circle>
                          <path
                            d="M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.3569 14.0689 11.1131 13.4117 11.5636C12.7283 12.0319 12 12.6716 12 13.5"
                            stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M12.0001 17H12.009" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        </svg>
                      </ng-template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>

        <!-- Draft tab -->
        <div [class.active]="tabs_grid === 'draft'" class="tab-pane" role="tabpanel" id="draft">
          <div class="luqta-card">
            <div class="card-heading">
              <h3>{{ 'contests.draft-contests' | translate }}</h3>
            </div>
            <nz-table #draftTable [nzData]="draftContests" [nzBordered]="true" [nzScroll]="{ x: '1200px' }"
              [nzFrontPagination]="false" [nzPageSize]="perPage" [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[5, 10, 20, 50]" [nzShowPagination]="true" [nzTotal]="totalDraftContestLength"
              [nzPageIndex]="draftPageIndex" (nzPageSizeChange)="onPageSizeChange($event)"
              (nzPageIndexChange)="onDraftPageIndexChange($event)"
              (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
              <thead>
                <tr>

                  <th nzWidth="300px">{{ "allContests.name" | translate }}</th>
                  <th nzWidth="150px">{{ 'contests.creation-date' | translate }}</th>
                  <th nzWidth="130px">{{ "allContests.accessCode" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.type" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.status" | translate }}</th>
                  <th nzWidth="140px">{{ "allContests.viewType" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.location" | translate }}</th>
                  <th nzWidth="250px">{{ "allContests.contestDate" | translate }}</th>
                  <th nzWidth="210px">{{ "allContests.prizeAnnouncementDate" | translate }}</th>
                  <th nzWidth="180px">{{ "allContests.timeline" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.no_of_participate" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.levels" | translate }}</th>
                  <th nzWidth="200px">{{ "allContests.prize" | translate }}</th>
                  <th nzWidth="110px">{{ "allContests.integrated" | translate }}</th>
                  <th nzWidth="165px" nzRight>{{ "allContests.actions" | translate }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of draftTable.data; let i = index">

                  <td>
                    <div class="contest-name">

                      <div class="image-group">
                        <img *ngFor="let banner of item.banners || []; let j = index" [src]="banner?.url" width="40"
                          height="40" class="banner-img clickable" alt="logo"
                          (click)="openImageModal(item.banners, j); $event.stopPropagation()" />
                      </div>
                      <span [innerHTML]="item.name | highlight : searchTerm"></span>
                    </div>
                  </td>

                  <td>{{ item.created_at | date }}</td>

                  <td class="text-center">{{ item.access_code }}</td>



                  <td>{{ item.type || item.contest_type || "-" }}</td>
                  <td>
                    <span class="d-inline-flex align-items-center px-2 py-1 rounded text-white"
                      [ngClass]="getStatusClass(getDisplayStatus(item))">
                      <i class="fas fa-pencil-alt me-1"></i> {{ getStatusLabel(getDisplayStatus(item)) }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <span class="badge" [ngClass]="
                      item.View_Type?.toLowerCase() === 'vip' ||
                  item.view_type?.toLowerCase() === 'vip' ||
                  item.viewType?.toLowerCase() === 'vip'
                        ? 'bg-warning'
                        : 'bg-info'
                    ">
                        {{ item.View_Type || item.view_type || item.viewType || "Normal" }}
                      </span>
                    </div>
                  </td>

                  <td class="text-center">
                    <span *ngIf="!hasMoreThanTwoLocations(item)">{{ item.location || item.contest_location || "-"
                      }}</span>
                    <span *ngIf="hasMoreThanTwoLocations(item)" [nz-tooltip]="item.location || item.contest_location"
                      nzTooltipPlacement="top" style="cursor: help;">
                      {{ getFirstTwoLocations(item) }}...
                    </span>
                  </td>

                  <td>
                    <ng-container *ngIf="item.start_date; else noStart">
                      {{ item.start_date | date }}
                    </ng-container>
                    -
                    <ng-container *ngIf="item.end_date; else noEnd">
                      {{ item.end_date | date }}
                    </ng-container>

                    <ng-template #noStart>-</ng-template>
                    <ng-template #noEnd>-</ng-template>
                  </td>

                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="item.prize_announce_date; else noPrizeDate">
                        {{ item.prize_announce_date | date }}
                      </ng-container>
                      <ng-template #noPrizeDate>-</ng-template>
                    </div>
                  </td>

                  <td>{{ getTimeRemaining(item.end_date) }}</td>

                  <td>
                    <ng-container *ngIf="item.contest_participate > 0; else noParticipate">
                      <span>{{ item.contest_participate }}</span>
                    </ng-container>
                    <ng-template #noParticipate><span>0</span></ng-template>
                  </td>

                  <td class="text-center">
                    <ng-container *ngIf="item.level_count > 0; else noLevels">
                      <span>{{ item.level_count }}</span>
                    </ng-container>
                    <ng-template #noLevels><span>-</span></ng-template>
                  </td>

                  <td class="text-center">{{ getPrizeNames(item._contest_prize) }}</td>

                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="
                      item.format_of_contest == 'integrated' ||
                      item.format_of_contest == 'intergrated';
                      else notIntegrated
                    ">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#7ed321" stroke-width="2" />
                          <path d="M8 12.75C8 12.75 9.6 13.6625 10.4 15C10.4 15 12.8 9.75 16 8" stroke="#7ed321"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-container>

                      <ng-template #notIntegrated>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#F40531" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#F40531" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-template>
                    </div>
                  </td>

                  <td nzRight>
                    <div class="table-action-btns">

                      <svg width="18" height="18" (click)="showContestDetail(item)" nz-tooltip
                        nzTooltipTitle="View Contest" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_40000187_8448" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8448)">
                          <path
                            d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                            fill="#1C1B1F" />
                        </g>
                      </svg>

                      <!-- 👥 Participants Icon -->
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        (click)="viewParticipants(item.id, item.name)" xmlns="http://www.w3.org/2000/svg" nz-tooltip
                        nzTooltipTitle="View Participants" style="cursor: pointer">
                        <path
                          d="M17 20C17 18.3431 14.7614 17 12 17C9.23858 17 7 18.3431 7 20M21 17.0004C21 15.7702 19.7659 14.7129 18 14.25M3 17.0004C3 15.7702 4.2341 14.7129 6 14.25M18 10.2361C18.6137 9.68679 19 8.8885 19 8C19 6.34315 17.6569 5 16 5C15.2316 5 14.5308 5.28885 14 5.76389M6 10.2361C5.38625 9.68679 5 8.8885 5 8C5 6.34315 6.34315 5 8 5C8.76835 5 9.46924 5.28885 10 5.76389M12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14Z"
                          stroke="#1C1B1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>

                      <svg width="18" (click)="editContest(item.id)" class="edit" nz-tooltip
                        nzTooltipTitle="Edit Contest" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_40000187_8939" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8939)">
                          <path
                            d="M3.70414 14.0745H4.75969L12.0004 6.83377L10.9449 5.77821L3.70414 13.019V14.0745ZM2.22266 15.556V12.4078L12.0004 2.64858C12.1486 2.51278 12.3122 2.40784 12.4912 2.33377C12.6702 2.25969 12.8585 2.22266 13.056 2.22266C13.2535 2.22266 13.4449 2.25969 13.6301 2.33377C13.8152 2.40784 13.9757 2.51895 14.1115 2.6671L15.1301 3.70414C15.2782 3.83994 15.3862 4.00043 15.4541 4.18562C15.522 4.3708 15.556 4.55599 15.556 4.74117C15.556 4.93871 15.522 5.12698 15.4541 5.30599C15.3862 5.485 15.2782 5.64858 15.1301 5.79673L5.3708 15.556H2.22266ZM11.4634 6.31525L10.9449 5.77821L12.0004 6.83377L11.4634 6.31525Z"
                            fill="#1C1B1F" />
                        </g>
                      </svg>



                      <svg (click)="confirmDeleteContest(item.id, item.name)" class="delete" nz-tooltip
                        nzTooltipTitle="Delete Contest" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
                        <mask id="mask0_40000187_8454_draft" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                          y="0" width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8454_draft)">
                          <path
                            d="M5.18707 15.556C4.77966 15.556 4.43089 15.4109 4.14077 15.1208C3.85065 14.8307 3.70558 14.4819 3.70558 14.0745V4.44488H2.96484V2.9634H6.66855V2.22266H11.113V2.9634H14.8167V4.44488H14.076V14.0745C14.076 14.4819 13.9309 14.8307 13.6408 15.1208C13.3506 15.4109 13.0019 15.556 12.5945 15.556H5.18707ZM12.5945 4.44488H5.18707V14.0745H12.5945V4.44488ZM6.66855 12.593H8.15003V5.92636H6.66855V12.593ZM9.63151 12.593H11.113V5.92636H9.63151V12.593Z"
                            fill="#F40531" />
                        </g>
                      </svg>

                      <ng-template #iconTpl>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                          style="margin-right: 5px" color="#d0021b" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"></circle>
                          <path
                            d="M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.3569 14.0689 11.1131 13.4117 11.5636C12.7283 12.0319 12 12.6716 12 13.5"
                            stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M12.0001 17H12.009" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        </svg>
                      </ng-template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>

        <!-- completed tab -->
        <div [class.active]="tabs_grid === 'completed'" class="tab-pane" role="tabpanel" id="completed">
          <div class="luqta-card">
            <div class="card-heading">
              <h3>
                {{ 'contests.completed-contests' | translate }}
              </h3>
            </div>
            <nz-table #completedTable [nzData]="completedContests" [nzBordered]="true" [nzScroll]="{ x: '1200px' }"
              [nzFrontPagination]="false" [nzPageSize]="perPage" [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[5, 10, 20, 50]" [nzShowPagination]="true" [nzTotal]="totalCompletedContestLength"
              [nzPageIndex]="completedPageIndex" (nzPageSizeChange)="onPageSizeChange($event)"
              (nzPageIndexChange)="onCompletedPageIndexChange($event)"
              (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
              <thead>
                <tr>
                  <!-- <th nzWidth="50px">
                  <div class="d-flex justify-content-center align-items-center">#</div>
                </th> -->
                  <th nzWidth="300px">{{ "allContests.name" | translate }}</th>
                  <!-- <th nzWidth="100px">{{ "allContests.banners" | translate }}</th> -->
                  <th nzWidth="150px">{{ 'contests.creation-date' | translate }}</th>
                  <th nzWidth="130px">{{ "allContests.accessCode" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.type" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.status" | translate }}</th>
                  <th nzWidth="140px">{{ "allContests.viewType" | translate }}</th>
                  <th nzWidth="150px">{{ "allContests.location" | translate }}</th>
                  <th nzWidth="250px">{{ "allContests.contestDate" | translate }}</th>
                  <th nzWidth="210px">{{ "allContests.prizeAnnouncementDate" | translate }}</th>
                  <th nzWidth="180px">{{ "allContests.timeline" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.no_of_participate" | translate }}</th>
                  <th nzWidth="100px">{{ "allContests.levels" | translate }}</th>
                  <th nzWidth="200px">{{ "allContests.prize" | translate }}</th>
                  <th nzWidth="110px">{{ "allContests.integrated" | translate }}</th>
                  <th nzWidth="165px" nzRight>{{ "allContests.actions" | translate }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of completedTable.data; let i = index">
                  <!-- <td>
                  <div class="d-flex justify-content-center align-items-center">
                    {{ (completedPageIndex - 1) * perPage + i + 1 }}
                  </div>
                </td> -->
                  <td>
                    <div class="contest-name">

                      <div class="image-group">
                        <img *ngFor="let banner of item.banners || []; let j = index" [src]="banner?.url" width="40"
                          height="40" class="banner-img clickable" alt="logo"
                          (click)="openImageModal(item.banners, j); $event.stopPropagation()" />
                      </div>
                      <span [innerHTML]="item.name | highlight : searchTerm"></span>
                    </div>
                  </td>

                  <td>{{ item.created_at | date }}</td>

                  <td>{{ item.access_code }}</td>



                  <td>{{ item.type || item.contest_type || "-" }}</td>
                  <td>
                    <span class="d-inline-flex align-items-center px-2 py-1 rounded text-white"
                      [ngClass]="getStatusClass(getDisplayStatus(item))">
                      {{ getStatusLabel(getDisplayStatus(item)) }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <span class="badge" [ngClass]="
                item.View_Type?.toLowerCase() === 'vip' ||
                  item.view_type?.toLowerCase() === 'vip' ||
                  item.viewType?.toLowerCase() === 'vip'
                  ? 'bg-warning'
                  : 'bg-info'
              ">
                        {{ item.View_Type || item.view_type || item.viewType || "Normal" }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <span *ngIf="!hasMoreThanTwoLocations(item)">{{ item.location || item.contest_location || "-"
                      }}</span>
                    <span *ngIf="hasMoreThanTwoLocations(item)" [nz-tooltip]="item.location || item.contest_location"
                      nzTooltipPlacement="top" style="cursor: help;">
                      {{ getFirstTwoLocations(item) }}...
                    </span>
                  </td>

                  <td>
                    <ng-container *ngIf="item.start_date; else noStart">
                      {{ item.start_date | date }}
                    </ng-container>
                    -
                    <ng-container *ngIf="item.end_date; else noEnd">
                      {{ item.end_date | date }}
                    </ng-container>

                    <ng-template #noStart>-</ng-template>
                    <ng-template #noEnd>-</ng-template>
                  </td>

                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="item.prize_announce_date; else noPrizeDate">
                        {{ item.prize_announce_date | date }}
                      </ng-container>
                      <ng-template #noPrizeDate>-</ng-template>
                    </div>
                  </td>

                  <td>{{ getTimeRemaining(item.end_date) }}</td>

                  <td>
                    <ng-container *ngIf="item.contest_participate > 0; else noParticipate">
                      <span>{{ item.contest_participate }}</span>
                    </ng-container>
                    <ng-template #noParticipate><span>0</span></ng-template>
                  </td>
                  <td>
                    <ng-container *ngIf="item.level_count > 0; else noLevels">
                      <span>{{ item.level_count }}</span>
                    </ng-container>
                    <ng-template #noLevels><span>0</span></ng-template>
                  </td>

                  <td>{{ getPrizeNames(item._contest_prize) }}</td>
                  <td>
                    <div class="d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="
                item.format_of_contest == 'integrated' ||
                  item.format_of_contest == 'intergrated';
                else notIntegrated
              ">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#7ed321" stroke-width="2" />
                          <path d="M8 12.75C8 12.75 9.6 13.6625 10.4 15C10.4 15 12.8 9.75 16 8" stroke="#7ed321"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-container>

                      <ng-template #notIntegrated>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none">
                          <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="#F40531" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#F40531" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </ng-template>
                    </div>
                  </td>


                  <td nzRight>
                    <div class="table-action-btns">
                      <svg (click)="showContestDetail(item)" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg" nz-tooltip nzTooltipTitle="View Contest">
                        <mask id="mask0_40000187_8448" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="18" height="18">
                          <rect width="17.7778" height="17.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_40000187_8448)">
                          <path
                            d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                            fill="#1C1B1F" />
                        </g>
                      </svg>

                      <!-- 👥 Participants Icon -->
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        (click)="viewParticipants(item.id, item.name)" xmlns="http://www.w3.org/2000/svg" nz-tooltip
                        nzTooltipTitle="View Participants" style="cursor: pointer">
                        <path
                          d="M17 20C17 18.3431 14.7614 17 12 17C9.23858 17 7 18.3431 7 20M21 17.0004C21 15.7702 19.7659 14.7129 18 14.25M3 17.0004C3 15.7702 4.2341 14.7129 6 14.25M18 10.2361C18.6137 9.68679 19 8.8885 19 8C19 6.34315 17.6569 5 16 5C15.2316 5 14.5308 5.28885 14 5.76389M6 10.2361C5.38625 9.68679 5 8.8885 5 8C5 6.34315 6.34315 5 8 5C8.76835 5 9.46924 5.28885 10 5.76389M12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14Z"
                          stroke="#1C1B1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
    <div class="luqta-card">
      <div class="contest-overview-section-wrapper" style="position: relative;">
        <div *ngIf="overviewLoading" class="section-loader">
          <div class="section-loader-container">
            <div class="section-loader-ring"></div>
            <div class="section-loader-ring section-loader-ring-2"></div>
            <img src="assets/images/luqta_favicon1.png" alt="Loading" class="section-loader-logo" />
          </div>
        </div>
        <div class="card-heading">
          <h3>
            {{ 'contests.contest-overview' | translate }}
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_40000187_8493" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14"
                height="14">
                <rect width="14" height="14" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_40000187_8493)">
                <path
                  d="M6.41797 9.91602H7.58464V6.41602H6.41797V9.91602ZM7.0013 5.24935C7.16658 5.24935 7.30512 5.19345 7.41693 5.08164C7.52873 4.96984 7.58464 4.83129 7.58464 4.66602C7.58464 4.50074 7.52873 4.3622 7.41693 4.25039C7.30512 4.13859 7.16658 4.08268 7.0013 4.08268C6.83602 4.08268 6.69748 4.13859 6.58568 4.25039C6.47387 4.3622 6.41797 4.50074 6.41797 4.66602C6.41797 4.83129 6.47387 4.96984 6.58568 5.08164C6.69748 5.19345 6.83602 5.24935 7.0013 5.24935ZM7.0013 12.8327C6.19436 12.8327 5.43602 12.6796 4.7263 12.3733C4.01658 12.0671 3.39922 11.6514 2.87422 11.1264C2.34922 10.6014 1.93359 9.98407 1.62734 9.27435C1.32109 8.56463 1.16797 7.80629 1.16797 6.99935C1.16797 6.1924 1.32109 5.43407 1.62734 4.72435C1.93359 4.01463 2.34922 3.39727 2.87422 2.87227C3.39922 2.34727 4.01658 1.93164 4.7263 1.62539C5.43602 1.31914 6.19436 1.16602 7.0013 1.16602C7.80825 1.16602 8.56658 1.31914 9.2763 1.62539C9.98602 1.93164 10.6034 2.34727 11.1284 2.87227C11.6534 3.39727 12.069 4.01463 12.3753 4.72435C12.6815 5.43407 12.8346 6.1924 12.8346 6.99935C12.8346 7.80629 12.6815 8.56463 12.3753 9.27435C12.069 9.98407 11.6534 10.6014 11.1284 11.1264C10.6034 11.6514 9.98602 12.0671 9.2763 12.3733C8.56658 12.6796 7.80825 12.8327 7.0013 12.8327ZM7.0013 11.666C8.30408 11.666 9.40755 11.2139 10.3117 10.3098C11.2159 9.4056 11.668 8.30213 11.668 6.99935C11.668 5.69657 11.2159 4.5931 10.3117 3.68893C9.40755 2.78477 8.30408 2.33268 7.0013 2.33268C5.69852 2.33268 4.59505 2.78477 3.69089 3.68893C2.78672 4.5931 2.33464 5.69657 2.33464 6.99935C2.33464 8.30213 2.78672 9.4056 3.69089 10.3098C4.59505 11.2139 5.69852 11.666 7.0013 11.666Z"
                  fill="#7A7A7A" />
              </g>
            </svg>
          </h3>
          <div style="display: flex; align-items: center; gap: 8px;">
            <nz-select [(ngModel)]="overviewContestId" (ngModelChange)="onOverviewContestChange($event)"
              nzPlaceHolder="All Contests" nzAllowClear nzShowSearch style="min-width: 160px;" nzSize="small">
              <nz-option *ngFor="let c of contestsList" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
            </nz-select>
            <div style="position: relative;">
              <button class="btn btn-date" (click)="overviewPickerOpen = !overviewPickerOpen">
                <span>
                  {{ overviewDateRange.length === 2 ? (formatDateToString(overviewDateRange[0]) + ' - ' +
                  formatDateToString(overviewDateRange[1])) : ('common.all-time' | translate) }}
                </span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_40000187_8501" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                    width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_40000187_8501)">
                    <path
                      d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V3.15377C6.69225 2.9346 6.76567 2.7516 6.9125 2.60477C7.05933 2.4581 7.24233 2.38477 7.4615 2.38477C7.68083 2.38477 7.86383 2.4581 8.0105 2.60477C8.15733 2.7516 8.23075 2.9346 8.23075 3.15377V4.50002H15.8077V3.13477C15.8077 2.92193 15.8795 2.74368 16.023 2.60002C16.1667 2.45652 16.3449 2.38477 16.5577 2.38477C16.7706 2.38477 16.9487 2.45652 17.0922 2.60002C17.2359 2.74368 17.3077 2.92193 17.3077 3.13477V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7692 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777ZM12 14.077C11.7552 14.077 11.5465 13.9908 11.374 13.8183C11.2017 13.6459 11.1155 13.4373 11.1155 13.1923C11.1155 12.9474 11.2017 12.7388 11.374 12.5663C11.5465 12.3939 11.7552 12.3078 12 12.3078C12.2448 12.3078 12.4535 12.3939 12.626 12.5663C12.7983 12.7388 12.8845 12.9474 12.8845 13.1923C12.8845 13.4373 12.7983 13.6459 12.626 13.8183C12.4535 13.9908 12.2448 14.077 12 14.077ZM8 14.077C7.75517 14.077 7.5465 13.9908 7.374 13.8183C7.20167 13.6459 7.1155 13.4373 7.1155 13.1923C7.1155 12.9474 7.20167 12.7388 7.374 12.5663C7.5465 12.3939 7.75517 12.3078 8 12.3078C8.24483 12.3078 8.4535 12.3939 8.626 12.5663C8.79833 12.7388 8.8845 12.9474 8.8845 13.1923C8.8845 13.4373 8.79833 13.6459 8.626 13.8183C8.4535 13.9908 8.24483 14.077 8 14.077ZM16 14.077C15.7552 14.077 15.5465 13.9908 15.374 13.8183C15.2017 13.6459 15.1155 13.4373 15.1155 13.1923C15.1155 12.9474 15.2017 12.7388 15.374 12.5663C15.5465 12.3939 15.7552 12.3078 16 12.3078C16.2448 12.3078 16.4535 12.3939 16.626 12.5663C16.7983 12.7388 16.8845 12.9474 16.8845 13.1923C16.8845 13.4373 16.7983 13.6459 16.626 13.8183C16.4535 13.9908 16.2448 14.077 16 14.077ZM12 18C11.7552 18 11.5465 17.9138 11.374 17.7413C11.2017 17.5689 11.1155 17.3603 11.1155 17.1155C11.1155 16.8705 11.2017 16.6618 11.374 16.4895C11.5465 16.317 11.7552 16.2308 12 16.2308C12.2448 16.2308 12.4535 16.317 12.626 16.4895C12.7983 16.6618 12.8845 16.8705 12.8845 17.1155C12.8845 17.3603 12.7983 17.5689 12.626 17.7413C12.4535 17.9138 12.2448 18 12 18ZM8 18C7.75517 18 7.5465 17.9138 7.374 17.7413C7.20167 17.5689 7.1155 17.3603 7.1155 17.1155C7.1155 16.8705 7.20167 16.6618 7.374 16.4895C7.5465 16.317 7.75517 16.2308 8 16.2308C8.24483 16.2308 8.4535 16.317 8.626 16.4895C8.79833 16.6618 8.8845 16.8705 8.8845 17.1155C8.8845 17.3603 8.79833 17.5689 8.626 17.7413C8.4535 17.9138 8.24483 18 8 18ZM16 18C15.7552 18 15.5465 17.9138 15.374 17.7413C15.2017 17.5689 15.1155 17.3603 15.1155 17.1155C15.1155 16.8705 15.2017 16.6618 15.374 16.4895C15.5465 16.317 15.7552 16.2308 16 16.2308C16.2448 16.2308 16.4535 16.317 16.626 16.4895C16.7983 16.6618 16.8845 16.8705 16.8845 17.1155C16.8845 17.3603 16.7983 17.5689 16.626 17.7413C16.4535 17.9138 16.2448 18 16 18Z"
                      fill="#1E005E" />
                  </g>
                </svg>
              </button>

              <!-- Date Range Filter - Below button -->
              <div *ngIf="overviewPickerOpen"
                style="position: absolute; top: 45px; right: 0; z-index: 1000; background: white; padding: 10px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
                <nz-range-picker [(ngModel)]="overviewDateRange"
                  (ngModelChange)="onOverviewDateChange($event); overviewPickerOpen = false"
                  [nzPlaceHolder]="['Start Date', 'End Date']" nzFormat="dd-MM-yyyy" style="width: 280px;">
                </nz-range-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Total Contests Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div class="icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="16" fill="#DBEAFF" />
                  <path
                    d="M16 19C16.8741 19 17.6171 18.7083 18.229 18.125C18.8409 17.5417 19.1469 16.8333 19.1469 16C19.1469 15.1667 18.8409 14.4583 18.229 13.875C17.6171 13.2917 16.8741 13 16 13C15.1259 13 14.3829 13.2917 13.771 13.875C13.1591 14.4583 12.8531 15.1667 12.8531 16C12.8531 16.8333 13.1591 17.5417 13.771 18.125C14.3829 18.7083 15.1259 19 16 19ZM16 17.8C15.4755 17.8 15.0297 17.625 14.6626 17.275C14.2955 16.925 14.1119 16.5 14.1119 16C14.1119 15.5 14.2955 15.075 14.6626 14.725C15.0297 14.375 15.4755 14.2 16 14.2C16.5245 14.2 16.9703 14.375 17.3374 14.725C17.7045 15.075 17.8881 15.5 17.8881 16C17.8881 16.5 17.7045 16.925 17.3374 17.275C16.9703 17.625 16.5245 17.8 16 17.8ZM16 21C14.4382 21 13.0134 20.6 11.7255 19.8C10.4376 19 9.42075 17.9444 8.67483 16.6333C8.61655 16.5333 8.57284 16.4306 8.54371 16.325C8.51457 16.2194 8.5 16.1111 8.5 16C8.5 15.8889 8.51457 15.7806 8.54371 15.675C8.57284 15.5694 8.61655 15.4667 8.67483 15.3667C9.42075 14.0556 10.4376 13 11.7255 12.2C13.0134 11.4 14.4382 11 16 11C17.5618 11 18.9866 11.4 20.2745 12.2C21.5624 13 22.5793 14.0556 23.3252 15.3667C23.3834 15.4667 23.4272 15.5694 23.4563 15.675C23.4854 15.7806 23.5 15.8889 23.5 16C23.5 16.1111 23.4854 16.2194 23.4563 16.325C23.4272 16.4306 23.3834 16.5333 23.3252 16.6333C22.5793 17.9444 21.5624 19 20.2745 19.8C18.9866 20.6 17.5618 21 16 21Z"
                    fill="#1C69FF" />
                </svg>
              </div>
              <div>
                <h6>{{ 'dashboard.totalContests' | translate }}</h6>
                <span
                  [class]="getTrendBadge(overviewTrends.totalContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.totalContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.totalContests).value | number:'1.0-0' }}%
                  {{ getTrendBadge(overviewTrends.totalContests).isPositive ?
                  ('dashboard.higher' | translate) : ('dashboard.lower' | translate) }}
                </span>
              </div>
              <div class="value">
                <h4>{{ overviewStats.totalContests | number }}</h4>
              </div>
            </div>
          </div>

          <!-- Active Contests Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div class="icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="16" fill="#D1FAE5" />
                  <path
                    d="M16 21.6C16.875 21.6 17.6187 21.2937 18.2312 20.6812C18.8438 20.0687 19.15 19.325 19.15 18.45C19.15 17.575 18.8438 16.8312 18.2312 16.2188C17.6187 15.6062 16.875 15.3 16 15.3C15.125 15.3 14.3812 15.6062 13.7687 16.2188C13.1562 16.8312 12.85 17.575 12.85 18.45C12.85 19.325 13.1562 20.0687 13.7687 20.6812C14.3812 21.2937 15.125 21.6 16 21.6ZM13.9525 14.39C14.1858 14.2617 14.4337 14.1596 14.6962 14.0838C14.9587 14.0079 15.2242 13.9583 15.4925 13.935L13.725 10.4H11.975L13.9525 14.39ZM12.08 20.76C11.8817 20.4217 11.7271 20.0571 11.6163 19.6663C11.5054 19.2754 11.45 18.87 11.45 18.45C11.45 18.03 11.5054 17.6246 11.6163 17.2337C11.7271 16.8429 11.8817 16.4783 12.08 16.14C11.59 16.3033 11.1875 16.5921 10.8725 17.0062C10.5575 17.4204 10.4 17.9017 10.4 18.45C10.4 18.9983 10.5575 19.4796 10.8725 19.8938C11.1875 20.3079 11.59 20.5967 12.08 20.76ZM19.92 20.76C20.41 20.5967 20.8125 20.3079 21.1275 19.8938C21.4425 19.4796 21.6 18.9983 21.6 18.45C21.6 17.9017 21.4425 17.4204 21.1275 17.0062C20.8125 16.5921 20.41 16.3033 19.92 16.14C20.1183 16.4783 20.2729 16.8429 20.3837 17.2337C20.4946 17.6246 20.55 18.03 20.55 18.45C20.55 18.87 20.4946 19.2754 20.3837 19.6663C20.2729 20.0571 20.1183 20.4217 19.92 20.76ZM16 23C15.5333 23 15.0871 22.9329 14.6613 22.7987C14.2354 22.6646 13.8417 22.4808 13.48 22.2475C13.375 22.2708 13.27 22.2854 13.165 22.2913C13.06 22.2971 12.9492 22.3 12.8325 22.3C11.7708 22.3 10.8667 21.9267 10.12 21.18C9.37333 20.4333 9 19.5292 9 18.4675C9 17.4525 9.33833 16.5833 10.015 15.86C10.6917 15.1367 11.5258 14.7342 12.5175 14.6525L10.2075 10.015C10.0908 9.78167 10.0996 9.55417 10.2337 9.3325C10.3679 9.11083 10.5692 9 10.8375 9H13.7425C14.0108 9 14.2529 9.07 14.4688 9.21C14.6846 9.35 14.8567 9.53667 14.985 9.77L16 11.8L17.015 9.77C17.1433 9.53667 17.3154 9.35 17.5312 9.21C17.7471 9.07 17.9892 9 18.2575 9H21.1625C21.4308 9 21.6321 9.11083 21.7663 9.3325C21.9004 9.55417 21.9092 9.78167 21.7925 10.015L19.5 14.6175C20.4917 14.7108 21.3229 15.1192 21.9937 15.8425C22.6646 16.5658 23 17.435 23 18.45C23 19.5233 22.6267 20.4333 21.88 21.18C21.1333 21.9267 20.2233 22.3 19.15 22.3C19.045 22.3 18.9371 22.2971 18.8263 22.2913C18.7154 22.2854 18.6075 22.2708 18.5025 22.2475C18.1408 22.4808 17.75 22.6646 17.33 22.7987C16.91 22.9329 16.4667 23 16 23ZM16 19.395L15.1425 20.0425C15.0725 20.1008 15.0025 20.1038 14.9325 20.0513C14.8625 19.9987 14.8392 19.9317 14.8625 19.85L15.195 18.7825L14.3375 18.17C14.2675 18.1117 14.2442 18.0446 14.2675 17.9688C14.2908 17.8929 14.3492 17.855 14.4425 17.855H15.4925L15.825 16.7175C15.8483 16.6358 15.9067 16.595 16 16.595C16.0933 16.595 16.1517 16.6358 16.175 16.7175L16.5075 17.855H17.5575C17.6508 17.855 17.7092 17.8929 17.7325 17.9688C17.7558 18.0446 17.7325 18.1117 17.6625 18.17L16.805 18.7825L17.1375 19.85C17.1608 19.9317 17.1375 19.9987 17.0675 20.0513C16.9975 20.1038 16.9275 20.1008 16.8575 20.0425L16 19.395ZM18.0475 14.39L20.0425 10.4H18.275L16.7875 13.375L17.12 14.04C17.2833 14.0867 17.4408 14.1363 17.5925 14.1887C17.7442 14.2413 17.8958 14.3083 18.0475 14.39Z"
                    fill="#00AC4F" />
                </svg>
              </div>
              <div>
                <h6>{{ 'dashboard.activeContests' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.activeContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.activeContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.activeContests).value | number:'1.0-0' }}%
                  {{ getTrendBadge(overviewTrends.activeContests).isPositive ?
                  ('dashboard.higher' | translate) : ('dashboard.lower' | translate) }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.activeContests | number }}</h4>
              </div>
            </div>
          </div>

          <!-- Pending Contests Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div class="icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="16" fill="#6826FC" fill-opacity="0.1" />
                  <path
                    d="M22.0173 23.5789L19.3816 20.9624L18.7825 22.78C18.716 22.9664 18.5895 23.0563 18.4031 23.0496C18.2168 23.043 18.0903 22.9464 18.0238 22.76L16.2067 16.7082C16.1535 16.5617 16.1867 16.4286 16.3065 16.3087C16.4263 16.1889 16.5595 16.1556 16.7059 16.2089L22.7561 18.0264C22.9425 18.093 23.039 18.2195 23.0456 18.4059C23.0523 18.5923 22.9624 18.7188 22.7761 18.7854L20.959 19.3846L23.5947 22.021C23.821 22.2474 23.9342 22.507 23.9342 22.8C23.9342 23.0929 23.821 23.3525 23.5947 23.5789C23.3684 23.8053 23.1055 23.9184 22.806 23.9184C22.5065 23.9184 22.2436 23.8053 22.0173 23.5789ZM15.9871 9.59784C14.2033 9.59784 12.6924 10.217 11.4544 11.4553C10.2164 12.6936 9.59741 14.2049 9.59741 15.9892C9.59741 17.6669 10.1499 19.105 11.2547 20.3033C12.3596 21.5017 13.744 22.1808 15.408 22.3406C15.6343 22.3672 15.8306 22.4671 15.997 22.6402C16.1634 22.8133 16.24 23.013 16.2267 23.2394C16.2134 23.4657 16.1302 23.6521 15.9771 23.7986C15.824 23.9451 15.6343 24.0117 15.408 23.9983C14.3697 23.9318 13.4012 23.6721 12.5027 23.2194C11.6042 22.7667 10.8188 22.1775 10.1465 21.4518C9.47428 20.7261 8.94846 19.8939 8.56908 18.9552C8.18969 18.0164 8 17.0278 8 15.9892C8 14.884 8.20966 13.8454 8.62898 12.8734C9.0483 11.9014 9.61738 11.0559 10.3362 10.3368C11.055 9.61781 11.9003 9.04858 12.8721 8.62915C13.8439 8.20972 14.8822 8 15.9871 8C18.077 8 19.8974 8.71237 21.4482 10.1371C22.999 11.5618 23.8477 13.3195 23.9941 15.41C24.0207 15.623 23.9575 15.8061 23.8044 15.9592C23.6513 16.1123 23.4616 16.1956 23.2353 16.2089C23.009 16.2222 22.806 16.149 22.6263 15.9892C22.4466 15.8294 22.3434 15.6363 22.3168 15.41C22.1171 13.8121 21.4216 12.444 20.2302 11.3055C19.0388 10.1671 17.6244 9.59784 15.9871 9.59784Z"
                    fill="url(#paint0_linear_40000187_8546)" />
                  <defs>
                    <linearGradient id="paint0_linear_40000187_8546" x1="2.7775" y1="37.4542" x2="27.7699" y2="24.6235"
                      gradientUnits="userSpaceOnUse">
                      <stop offset="0.14" stop-color="#8F67FD" />
                      <stop offset="1" stop-color="#5304FB" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div>
                <h6>{{ 'dashboard.pendingContests' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.pendingContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.pendingContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.pendingContests).value | number:'1.0-0' }}%
                  {{ getTrendBadge(overviewTrends.pendingContests).isPositive ?
                  ('dashboard.higher' | translate) : ('dashboard.lower' | translate) }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.pendingContests | number }}</h4>
              </div>
            </div>
          </div>

          <!-- Finished Contests Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div class="icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="16" fill="#FFEDD4" />
                  <path
                    d="M16.375 15.9625C16.7375 15.5625 17.0156 15.1062 17.2094 14.5938C17.4031 14.0813 17.5 13.55 17.5 13C17.5 12.45 17.4031 11.9188 17.2094 11.4062C17.0156 10.8938 16.7375 10.4375 16.375 10.0375C17.125 10.1375 17.75 10.4688 18.25 11.0312C18.75 11.5938 19 12.25 19 13C19 13.75 18.75 14.4062 18.25 14.9688C17.75 15.5312 17.125 15.8625 16.375 15.9625ZM20.0875 22C20.225 21.775 20.3281 21.5344 20.3969 21.2781C20.4656 21.0219 20.5 20.7625 20.5 20.5V19.75C20.5 19.3 20.4 18.8719 20.2 18.4656C20 18.0594 19.7375 17.7 19.4125 17.3875C20.05 17.6125 20.6406 17.9031 21.1844 18.2594C21.7281 18.6156 22 19.1125 22 19.75V20.5C22 20.9125 21.8531 21.2656 21.5594 21.5594C21.2656 21.8531 20.9125 22 20.5 22H20.0875ZM22 15.25H21.25C21.0375 15.25 20.8594 15.1781 20.7156 15.0344C20.5719 14.8906 20.5 14.7125 20.5 14.5C20.5 14.2875 20.5719 14.1094 20.7156 13.9656C20.8594 13.8219 21.0375 13.75 21.25 13.75H22V13C22 12.7875 22.0719 12.6094 22.2156 12.4656C22.3594 12.3219 22.5375 12.25 22.75 12.25C22.9625 12.25 23.1406 12.3219 23.2844 12.4656C23.4281 12.6094 23.5 12.7875 23.5 13V13.75H24.25C24.4625 13.75 24.6406 13.8219 24.7844 13.9656C24.9281 14.1094 25 14.2875 25 14.5C25 14.7125 24.9281 14.8906 24.7844 15.0344C24.6406 15.1781 24.4625 15.25 24.25 15.25H23.5V16C23.5 16.2125 23.4281 16.3906 23.2844 16.5344C23.1406 16.6781 22.9625 16.75 22.75 16.75C22.5375 16.75 22.3594 16.6781 22.2156 16.5344C22.0719 16.3906 22 16.2125 22 16V15.25ZM13 16C12.175 16 11.4688 15.7063 10.8813 15.1188C10.2938 14.5312 10 13.825 10 13C10 12.175 10.2938 11.4688 10.8813 10.8813C11.4688 10.2938 12.175 10 13 10C13.825 10 14.5312 10.2938 15.1187 10.8813C15.7063 11.4688 16 12.175 16 13C16 13.825 15.7063 14.5312 15.1187 15.1188C14.5312 15.7063 13.825 16 13 16ZM7 20.5V19.9C7 19.475 7.10937 19.0844 7.32812 18.7281C7.54688 18.3719 7.8375 18.1 8.2 17.9125C8.975 17.525 9.7625 17.2344 10.5625 17.0406C11.3625 16.8469 12.175 16.75 13 16.75C13.825 16.75 14.6375 16.8469 15.4375 17.0406C16.2375 17.2344 17.025 17.525 17.8 17.9125C18.1625 18.1 18.4531 18.3719 18.6719 18.7281C18.8906 19.0844 19 19.475 19 19.9V20.5C19 20.9125 18.8531 21.2656 18.5594 21.5594C18.2656 21.8531 17.9125 22 17.5 22H8.5C8.0875 22 7.73438 21.8531 7.44063 21.5594C7.14688 21.2656 7 20.9125 7 20.5ZM13 14.5C13.4125 14.5 13.7656 14.3531 14.0594 14.0594C14.3531 13.7656 14.5 13.4125 14.5 13C14.5 12.5875 14.3531 12.2344 14.0594 11.9406C13.7656 11.6469 13.4125 11.5 13 11.5C12.5875 11.5 12.2344 11.6469 11.9406 11.9406C11.6469 12.2344 11.5 12.5875 11.5 13C11.5 13.4125 11.6469 13.7656 11.9406 14.0594C12.2344 14.3531 12.5875 14.5 13 14.5ZM8.5 20.5H17.5V19.9C17.5 19.7625 17.4656 19.6375 17.3969 19.525C17.3281 19.4125 17.2375 19.325 17.125 19.2625C16.45 18.925 15.7688 18.6719 15.0813 18.5031C14.3938 18.3344 13.7 18.25 13 18.25C12.3 18.25 11.6062 18.3344 10.9187 18.5031C10.2312 18.6719 9.55 18.925 8.875 19.2625C8.7625 19.325 8.67188 19.4125 8.60313 19.525C8.53438 19.6375 8.5 19.7625 8.5 19.9V20.5Z"
                    fill="url(#paint0_linear_40000187_8559)" />
                  <defs>
                    <linearGradient id="paint0_linear_40000187_8559" x1="9.19231" y1="14.5882" x2="28.1746" y2="27.294"
                      gradientUnits="userSpaceOnUse">
                      <stop offset="0.101119" stop-color="#FB513F" />
                      <stop offset="1" stop-color="#FC8B2E" stop-opacity="0.46" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div>
                <h6>{{ 'dashboard.finishedContests' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.finishedContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.finishedContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.finishedContests).value | number:'1.0-0' }}%
                  {{ getTrendBadge(overviewTrends.finishedContests).isPositive
                  ? ('dashboard.higher' | translate) : ('dashboard.lower' | translate) }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.finishedContests | number }}</h4>
              </div>
            </div>
          </div>

          <!-- Average Click Rate Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div>
                <h6>{{ 'contests.overall-success-rate' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.overallSuccessRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.overallSuccessRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.overallSuccessRate).value | number:'1.0-0' }}%
                  {{ getTrendBadge(overviewTrends.overallSuccessRate).isPositive ? 'Higher' : 'Lower' }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.avgClickRate | number:'1.0-2' }}%</h4>
              </div>
              <div>
                <div class="progress">
                  <div class="progress-fill"
                    [style.width.%]="overviewStats.avgClickRate > 100 ? 100 : overviewStats.avgClickRate"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Average Completion Rate Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div>
                <h6>{{ 'dashboard.avgCompletionRate' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.avgCompletionRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.avgCompletionRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.avgCompletionRate).value | number:'1.0-0' }}%
                  {{ getPercentageChange(overviewStats.avgCompletionRate,
                  previousStats.avgCompletionRate).isPositive ? 'Higher' : 'Lower' }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.avgCompletionRate | number:'1.2-2' }}%</h4>
              </div>
              <div>
                <div class="progress">
                  <div class="progress-fill"
                    [style.width.%]="overviewStats.avgCompletionRate > 100 ? 100 : overviewStats.avgCompletionRate">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Average Participation Rate Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div>
                <h6>{{ 'dashboard.avgParticipationRate' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.avgParticipationRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.avgParticipationRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getPercentageChange(overviewStats.avgParticipationRate,
                  previousStats.avgParticipationRate).value | number:'1.0-0' }}%
                  {{ getPercentageChange(overviewStats.avgParticipationRate,
                  previousStats.avgParticipationRate).isPositive ? 'Higher' : 'Lower' }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.avgParticipationRate | number:'1.2-2' }}%</h4>
              </div>
              <div>
                <div class="progress">
                  <div class="progress-fill"
                    [style.width.%]="overviewStats.avgParticipationRate > 100 ? 100 : overviewStats.avgParticipationRate">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Average Engagement Rate Card -->
          <div class="col-lg-3">
            <div class="contest-ov-card">
              <div>
                <h6>{{ 'dashboard.avgEngagementRate' | translate }}</h6>
                <div
                  [class]="getTrendBadge(overviewTrends.avgEngagementRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
                  <img
                    [src]="getTrendBadge(overviewTrends.avgEngagementRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                    alt="">
                  {{ getTrendBadge(overviewTrends.avgEngagementRate).value | number:'1.0-0' }}%
                  {{ getPercentageChange(overviewStats.avgEngagementRate,
                  previousStats.avgEngagementRate).isPositive ? 'Higher' : 'Lower' }}
                </div>
              </div>
              <div>
                <h4>{{ overviewStats.avgEngagementRate | number:'1.2-2' }}%</h4>
              </div>
              <div>
                <div class="progress">
                  <div class="progress-fill"
                    [style.width.%]="overviewStats.avgEngagementRate > 100 ? 100 : overviewStats.avgEngagementRate">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>


  <app-filter-modal [(isVisible)]="filterModalVisible" [config]="filterConfig" [initialFilters]="currentFilters"
    (filtersApplied)="onFiltersApplied($event)" (filtersReset)="onFiltersReset()"></app-filter-modal>

  <!-- Image Modal -->
  <app-image-modal [isVisible]="imageModalVisible" [images]="imageModalImages" [currentIndex]="imageModalCurrentIndex"
    [alt]="'Contest Banner'" (closeModal)="closeImageModal()" (indexChange)="onImageIndexChange($event)">
  </app-image-modal>

  <!-- Undo Delete Notification Template -->
  <ng-template #undoNotificationTpl let-data="data">
    <div class="undo-notification-content">
      <div class="undo-message">
        <i class="fa-solid fa-trash-can trash-icon"></i>
        <span>"{{ data.contestName?.length > 5 ? (data.contestName | slice:0:5) + '...' : data.contestName }}"
          deleted</span>
      </div>
      <button class="undo-btn" (click)="undoDelete(data.id)">
        <i class="fa-solid fa-rotate-left"></i>
        Undo
      </button>
    </div>
  </ng-template>
</div>